<template>
    <div class="row" v-if="estado">
        <div class="col-md-6">
            <div class="m-5">
                <div>
                    <h5 class="text-capitalize" >{{minusculas(modelo)}} {{anio}}</h5>
                </div>
                <table>
                    <tbody>
                    <tr v-for="item in resumen" :key="item.id">
                        <td>
                            <h6>{{item.dt1}}</h6>
                        </td>
                        <td class="pl-5 text-right">
                            <h6 class="precio-syb">{{puntos(item.ndt1)}}</h6>
                        </td>
                    </tr>
                    <tr class="sum-total">
                        <td>
                            <h6>
                                <b>Precio del vehículo</b>
                            </h6>
                        </td>
                        <td class="pl-5 text-right" >
                            <h6 class="precio-syb font-weight-bold">{{puntos(suma(resumen))}}</h6>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="m-5" v-if="accesorios.length">
                <div>
                    <h5 class="text-capitalize" >Accesorios</h5>
                </div>
                <table>
                    <tbody>
                    <tr v-for="item in accesorios" :key="item.id">
                        <td>
                            <h6>{{item.dt2}}</h6>
                        </td>
                        <td class="pl-5 text-right">
                            <h6 class="precio-syb">{{puntos(item.ndt2)}}</h6>
                        </td>
                    </tr>
                    <tr class="sum-total">
                        <td>
                            <h6>
                                <b>Total de accesorios</b>
                            </h6>
                        </td>
                        <td class="pl-5 text-right">
                            <h6 class="precio-syb font-weight-bold">{{puntos(suma2(accesorios,[]))}}</h6>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
          <div class="m-5" v-if="cupones.length">
            <div>
              <h5 class="text-capitalize">Mantenimientos prepagados</h5>
            </div>
            <table>
              <tbody>
              <tr v-for="item in cupones" :key="item.id">
                <td>
                  <h6>{{item.dt1}}</h6>
                </td>
                <td class="pl-5 text-right">
                  <h6 class="precio-syb">{{puntos(item.ndt3)}}</h6>
                </td>
              </tr>
              <tr class="sum-total">
                <td>
                  <h6>
                    <b>Total de mantenimientos</b>
                  </h6>
                </td>
                <td class="pl-5 text-right">
                  <h6 class="precio-syb font-weight-bold">{{puntos(suma3('ndt3',cupones))}}</h6>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
            <imagen :cargando="false" :activo360="false" :activar="false"></imagen>
        </div>
    </div>
</template>

<script>
    import constantes from "../../constantes";
    import imagen from "../Paso2/Imagen/imagen-vehiculo";
    export default {
        name: "resumen-modal",
        props:["estado"],
        components:{
            imagen,
        },
        computed:{
            modelo:function(){
                return this.$store.getters.getPasos[1].modelo.dt1 || null
            },
            anio:function(){
                return this.$store.getters.getPasos[2].version.ndt10 || null
            },
            accesorios:function(){
                if(this.$store.getters.getPasos[2]){
                    let todos=[];
                    todos=todos.concat(this.$store.getters.getPasos[2].accesorios.individuales);
                    todos=todos.concat(this.$store.getters.getPasos[2].accesorios.kit);
                    return todos;
                }else{
                    return [];
                }
            },
          cupones:function(){
              return this.$store.getters.getPasos[2].accesorios.cupones;
          },
            resumen:function(){
                if(this.$store.getters.getPasos[3].resumen.length)
                    return this.$store.getters.getPasos[3].resumen;
                else
                    return [
                        {
                            id:"defecto",
                            dt1:"Base",
                            ndt1:this.$store.getters.getPrecio,
                        }
                    ];
            }
        },
        methods: {
            minusculas: (dato) => constantes.funciones.minusculas(dato),
            puntos: (numero) => constantes.funciones.puntoMilesDecimal(numero),
            suma: (vector) => constantes.funciones.sumar(vector),
            suma2: (vector1, vector2) => constantes.funciones.sumar2(vector1, vector2),
          suma3: (key,vector) => constantes.funciones.sumar3(key,vector),
        }
    }
</script>

<style scoped>
    .precio-syb::before {
        vertical-align: super;
        font-size: 0.55em;
        content: '$';
    }
    .sin-pad {
        padding: 0px;
    }

</style>
